var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "room-rates" },
    [
      _c(
        "div",
        {
          staticClass: "rate-list",
          class: { "single-item": !_vm.moreThanOneRate },
        },
        [
          _c("rate-item", {
            attrs: {
              rate: _vm.preferredRoomRate,
              room: _vm.room,
              "bed-type": _vm.bedType,
            },
            on: {
              select: function ($event) {
                _vm.selectedRate = $event
              },
              continue: _vm.keepRate,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow,
                  expression: "isShow",
                },
              ],
              attrs: { clas: "collapsible-rates" },
            },
            _vm._l(_vm.additionalRoomRates, function (rate, index) {
              return _c("rate-item", {
                key: "rate" + index,
                attrs: { rate: rate, room: _vm.room, "bed-type": _vm.bedType },
                on: {
                  select: function ($event) {
                    _vm.selectedRate = $event
                  },
                  continue: _vm.keepRate,
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.moreThanOneRate
            ? _c(
                "button",
                {
                  staticClass: "rate-list-cta",
                  class: { open: _vm.isShow },
                  attrs: { "aria-expanded": _vm.isShow ? "true" : "false" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleRateList($event)
                    },
                    enter: _vm.toggleRateList,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.toggleRateList($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        !_vm.isShow
                          ? _vm.tc("booking.seeMoreRates")
                          : _vm.tc("booking.seeFewerRates")
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-right" } },
        [
          _vm.selectedRate
            ? _c("rate-details", {
                attrs: {
                  rate: _vm.selectedRate,
                  room: _vm.room,
                  "bed-type": _vm.bedType,
                },
                on: {
                  close: function ($event) {
                    _vm.selectedRate = null
                  },
                  continue: _vm.keepRate,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.selectedRate
          ? _c("div", {
              staticClass: "backlight",
              on: {
                click: function ($event) {
                  _vm.selectedRate = null
                },
              },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }